module.exports = __webpack_public_path__ + "img/purple-square-table-8.33c53d5c.png";